<template>
  <div class="page-content page-projets">
    <headercomponent ref="header"></headercomponent>
    <div class="inner-content">
      <h1>{{ $t('Projets') }}</h1>
      <div class="projects-wrapper" v-if="projectsLoaded">
        <router-link
          :to="slugExtraction(project)"
          v-for="(project, index) in projects"
          :key="index"
          class="project"
        >
          <div
            class="bg"
            :style="`background-image: url(${cUrl_part_1}${screenSize}${cUrl_part_2}${project.image})`"
          ></div>
          <div class="legend">
            <h5 class="title">
              <div v-html="project.title"></div>
              <span>→</span>
            </h5>
            <h5 class="voir">
              {{ $t('voir-le-projet') }}
              <span>→</span>
            </h5>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Isotope from 'isotope-layout';
import { api } from '@/axios-config';
import { TimelineMax, Power4, Expo } from 'gsap';
import HeaderComponent from '@/components/Modules/HeaderComponent';
import store from '@/store/store';

export default {
  name: 'Projets',
  data() {
    return {
      cUrl_part_1: 'https://res.cloudinary.com/dfrhbuipn/image/upload/w_',
      cUrl_part_2: '/v1541424180/',
      screenSize: '1000',
      projects: [],
      projectsLoaded: false,
    };
  },
  created() {
    this.getProjects();
  },
  mounted() {
    store.commit('menuToggle', 'close');
    const desiredSize = 0.8 * window.innerWidth;
    const sizes = [500, 750, 1000, 1500, 2000];
    let result = sizes.filter(number => number > desiredSize);
    if (result === undefined || result.length === 0) {
      result = [2000];
    }
    this.screenSize = String(this.closestNumber(result, desiredSize));
    setTimeout(this.startSwiper, 1500);
    setTimeout(this.isotope, 600);
  },
  methods: {
    getProjects() {
      this.projects = [];
      this.projectsLoaded = false;
      let category = '30';
      if (this.currentlang === 'de') {
        category = '32';
      }
      api
        .get(`projet?categories=${category}&per_page=30`)
        .then(response => {
          response.data.forEach(element => {
            const nameOfImageCloudinary = element.acf.image_principale.url.split('/').pop();
            this.projects.push({
              slug: element.slug,
              title: element.title.rendered,
              image: nameOfImageCloudinary,
            });
          });
          this.projectsLoaded = true;
        })
        .catch(error => {
          console.error(`Load projects error 😱😱😱: ${error}`);
        });
    },
    isotope() {
      this.iso = new Isotope('.projects-wrapper', {
        itemSelector: '.project',
        layout: 'fitRows',
      });
    },
    slugExtraction(item) {
      return `/projets/${item.slug}`;
    },
    /* eslint-disable-next-line */
    closestNumber: function(array, num) {
      let minDiff = 1000;
      let ans;

      array.forEach(value => {
        const diff = Math.abs(num - value);
        if (diff < minDiff) {
          minDiff = diff;
          ans = value;
        }
      });

      return ans;
    },
  },
  components: {
    headercomponent: HeaderComponent,
  },
  watch: {
    currentlang() {
      const that = this;
      const logoPaths = document.querySelectorAll('.a11, .a12, .a21, .a22, .s1, .s2');
      const tl = new TimelineMax();
      tl.to('.headerline', 0.8, { scaleX: 0, transformOrigin: '0% 50%', ease: Expo.easeInOut }, 0);
      tl.to(logoPaths, 0.8, { scale: 0, transformOrigin: '0% 50%', ease: Power4.easeInOut }, 0);
      tl.to('footer', 1, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.to('.inner-content', 1, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.to('#menu-wrapper', 1, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.add(() => {
        that.getProjects();
        window.scroll(0, 1);
      }, 1);
      tl.to('.headerline', 1, { scaleX: 1, transformOrigin: '0% 50%', ease: Expo.easeInOut }, 1);
      tl.to(logoPaths, 1, { scale: 1, transformOrigin: '0% 50%', ease: Power4.easeInOut }, 1);
      tl.to('footer', 1, { autoAlpha: 1 }, 1.3);
      tl.to('.inner-content', 1, { autoAlpha: 1, ease: Power4.easeOut }, 2);
      tl.to('#menu-wrapper', 1, { autoAlpha: 1, ease: Power4.easeOut }, 2);
    },
  },
  computed: {
    currentlang() {
      return store.state.i18n.locale;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';
.inner-content {
  width: 80%;
  margin: 90px auto 0 auto;
  @include md {
    margin: 80px auto 0 auto;
  }
  @include sm {
    margin: 65px 10% 0 5%;
    width: auto;
  }
  @include xs {
    margin: 50px 15% 0 5%;
  }
  h1 {
    margin-bottom: 50px;
    @include sm {
      margin-bottom: 35px;
    }
    @include xs {
      margin-bottom: 25px;
    }
  }
}
// =====================================================
// Projects
// =====================================================
.projects-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -20px;
  .project {
    position: relative;
    width: 50%;
    padding: 0 20px;
    margin-bottom: 50px;
    outline: 0;
    h5 div {
      display: inline;
    }
    h5 span {
      padding-left: 5px;
    }
    .legend {
      margin-top: 15px;
      position: relative;
      overflow: hidden;
    }
    .title {
      opacity: 1;
      transform: translateX(0);
      transition: all 0.4s ease 0.2s;
    }
    .voir {
      position: absolute;
      top: 0;
      transform: translateX(-110%);
      transition: all 0.3s ease;
    }
    .bg {
      opacity: 1;
      height: 100%;
      background-size: cover;
      background-position: center center;
      padding-top: 66.66%;
      transition: opacity 0.5s ease;
    }
    &:hover {
      .bg {
        opacity: 0.7;
      }
      .title {
        opacity: 0;
        transform: translateX(20px);
        transition: all 0.3s ease;
      }
      .voir {
        transform: translateX(0);
        transition: all 0.4s ease 0.1s;
      }
    }
  }
  @include md {
    margin: 0 -10px;
    .project {
      width: 100%;
      padding: 0 10px;
      margin-bottom: 35px;
    }
  }
  @include sm {
    .project {
      margin-bottom: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projets.vue